import { render } from "./OuterContentsInput.vue?vue&type=template&id=5ad751f8&scoped=true&ts=true"
import script from "./OuterContentsInput.vue?vue&type=script&lang=ts"
export * from "./OuterContentsInput.vue?vue&type=script&lang=ts"

import "./OuterContentsInput.vue?vue&type=style&index=0&id=5ad751f8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad751f8"]])

export default __exports__